module.exports = __webpack_public_path__ + "static/img/swiper2.a6debfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper2.jpg
// module id = lv4q
// module chunks = 1